module.exports = __webpack_public_path__ + "static/media/vocabulary-easy-5000.3bdffa25.png";